import { cn } from "@/lib/utils";
import { Checkbox } from "@cmde/shadcn";

export function CheckboxSelectRow({
  name,
  checked,
  onCheckedChange,
  checkboxId,
  className,
}: {
  name: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  checkboxId: string;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-2 py-2 pr-4 hover:bg-muted/30", className)}>
      <Checkbox
        variant="simple"
        id={checkboxId}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <label htmlFor={checkboxId} className="min-w-0 flex-1 truncate text-sm">
        {name}
      </label>
    </div>
  );
}
